import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { DialogAction, useModal } from '../../../../function/useModal';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@material-ui/core';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import { ApiResponseCode, InsertIoTSet, IOT_SET } from './IoTBoxSetting';
import { GetNameDevSetList, NAME_DEV_SET } from '../../../../function/NameDevSetModel';
import TimeEntry from '../../../atoms/Input/TimeEntry';
import NumericWithNullEntry from '../../../atoms/Input/NumericWithNullEntry';
import SimpleDialog from '../../../atoms/Dialog/SimpleDialog';
import NumericEntry_inputEx from '../../../atoms/Input/NumericEntry_inputEx';
import { TableUseStyle, IoTBoxSettingStyle } from './IoTBoxSettingStyle';

export type IoTBoxSettingRowNewDialogProps = {
  dialog: DialogAction<IoTBoxSettingRowNewDialogResponse>;
};

export type IoTBoxSettingRowNewDialogResponse = {};

/**
 * IoTBox設定 新規登録ダイアログ
 * @param props
 * @returns
 */
const IoTBoxSettingRowNewDialog: React.FC<IoTBoxSettingRowNewDialogProps> = (props: IoTBoxSettingRowNewDialogProps) => {
  const tableBaseStyle = TableUseStyle();
  const pageStyle = IoTBoxSettingStyle();

  const { t } = useTranslation();

  const [imsiNo, setImsiNo] = useState<string>('');
  // 機器番号
  const [devNoTyp, setDevNoTyp] = useState<number>();
  // 収集時間
  const [logHour, setLogHour] = useState<string>('0');
  const [logMin, setlogMin] = useState<string>('0');
  const [logSec, setLogSec] = useState<string>('0');

  const [lithiumBattery, setLithiumBattery] = useState<number>();

  const [isOpen, setOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [nameDevCombos, setNameDevCombos] = useState<ComboBoxItemType[]>([]);
  //APIレスポンスダイアログ
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showTitle, setShowTitle] = React.useState<string>('');
  const [showMessage, setShowMessage] = React.useState<string>('');

  //機器番号取得
  useEffect(() => {
    GetNameDevSetList().then((res) => {
      console.debug(['res', res]);
      //実装のみ選択可
      setNameDevCombos(
        res
          .filter((ci) => ci.EST === 1)
          .map<ComboBoxItemType>((ci) => {
            return { index: ci.DEV_INDEX, name: ci.DEV_NO };
          })
      );
      setDevNoTyp(res.length == 0 ? 0 : 1);
    });
  }, []);

  const handleDialogClose = () => {
    console.debug('handleDialogClose()');
    setOpen(false);
    setMode(false);
  };

  /**
   * 新規登録状態更新処理呼び出し
   */
  const newBtnAction = () => {
    let data = {} as IOT_SET;
    data.IMSI_NO = imsiNo;
    data.DEV_INDEX = devNoTyp == undefined ? 0 : devNoTyp;
    data.LOG_HOUR = logHour;
    data.LOG_MIN = logMin;
    data.LOG_SEC = logSec;
    data.MOBILE_BATTERY = 0;
    data.LITHIUM_BATTERY = lithiumBattery;
    data.PLC_NO = 0;
    console.debug(['--- newBtnAction ---', data]);

    InsertIoTSet(data).then((status: number) => {
      console.debug(['status', status]);
      if (status == ApiResponseCode.SUCCESS) {
        // 新規登録要求をレコード追加 新規登録非同期待ち
        setOpen(false);
        setMode(true);
        return;
      }
      // エラー
      setShowTitle(t('IoTBoxSettingRowNewDialog.新規登録エラー', '新規登録エラー'));
      if (status == ApiResponseCode.BAD_REQUEST) {
        // パラメータ異常時
        setShowMessage(t('IoTBoxSettingRowNewDialog.パラメータに誤りがあります', 'パラメータに誤りがあります'));
      } else if (status == ApiResponseCode.DevIndexConanRegistered) {
        // 既に登録済み
        setShowMessage(
          t(
            'IoTBoxSettingRowNewDialog.コナンエアー管理画面側で使用中の機器番号と重複したため中断しました',
            'コナンエアー管理画面側で使用中の「機器番号」と重複したため中断しました'
          )
        );
      } else if (status == ApiResponseCode.NOT_ACCEPTABLE) {
        // 既に登録済み
        setShowMessage(
          t(
            'IoTBoxSettingRowNewDialog.「IMSI」もしくは「PLCNo」が既に登録済みです',
            '「IMSI」もしくは　[機器番号]もしくは「PLCNo」が既に登録済みです'
          )
        );
      } else if (status == ApiResponseCode.PLC_NO_FULL_ERROR) {
        setShowMessage(
          t(
            'IoTBoxSettingRowNewDialog.TMBee_Boxで登録できるTMBee_BoxNOに空きがありません',
            'TMBee-Boxで登録できる「TMBee-BoxNO」に空きがありません'
          )
        )
      }
      else {
        // 更新失敗時
        setShowMessage(t('IoTBoxSettingRowNewDialog.システムエラーが発生しました', 'システムエラーが発生しました'));
      }
      setMessageDialogOpen(true);
    });
  };

  console.debug(['- 画面描画開始 -', 'mode:', mode]);
  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {t('IoTBoxSettingRowNewDialog.IoTBox新規登録', 'IoTBox新規登録')}
        </DialogTitle>
        <DialogContent>
          <TableContainer className={pageStyle.tableDialgContainer}>
            <Table aria-label="judgeSetting">
              <TableBody>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell} width={250}>
                    IMSI
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter} width={200}>
                    <input
                      className={tableBaseStyle.textField}
                      type="text"
                      maxLength={15}
                      defaultValue={imsiNo}
                      value={imsiNo}
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        if (e.target.value === '' || re.test(e.target.value)) {
                          setImsiNo(e.target.value);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/* 機器番号 プルダウン */}
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTBoxSettingRowNewDialog.機器番号', '機器番号')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter}>
                    <ItemComboBox
                      label=""
                      itemList={nameDevCombos}
                      value={devNoTyp}
                      onChangeEvent={(e) => {
                        console.debug(['onChangeEvent', e.target.value]);
                        if (typeof e.target.value === 'string') {
                          const val = parseInt(e.target.value);
                          setDevNoTyp(val);
                        }
                      }}
                    />
                  </TableCell>
                </TableRow>
                {/* 収集時間 */}
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTBoxSettingRowNewDialog.収集時間', '収集時間')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter}>
                    <div className={pageStyle.flexBox}>
                      <TimeEntry
                        value={logHour}
                        maxValue={23}
                        minValue={0}
                        className={tableBaseStyle.logTimeField}
                        onChange={(val) => {
                          setLogHour(val);
                        }}
                      />
                      :
                      <TimeEntry
                        value={logMin}
                        maxValue={59}
                        minValue={0}
                        className={tableBaseStyle.logTimeField}
                        onChange={(val) => {
                          setlogMin(val);
                        }}
                      />
                      :
                      <TimeEntry
                        value={logSec}
                        maxValue={59}
                        minValue={0}
                        className={tableBaseStyle.logTimeField}
                        onChange={(val) => {
                          setLogSec(val);
                        }}
                      />
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={tableBaseStyle.headerCell}>
                    {t('IoTBoxSettingRowNewDialog.リチウムバッテリ寿命', 'リチウムバッテリ寿命')}
                  </TableCell>
                  <TableCell className={tableBaseStyle.bodyCellCenter}>
                    <NumericEntry_inputEx
                      value={lithiumBattery ?? 0}
                      maxValueLimit={9999}
                      fixed={0}
                      className={tableBaseStyle.textField}
                      onChange={(val) => {
                        console.debug(['onChange()', val]);
                        setLithiumBattery(val);
                      }}
                    //maxLen={4}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleDialogClose}
          >
            {t('IoTBoxSettingRowNewDialog.キャンセル', 'キャンセル')}
          </Button>
          <Button
            disabled={imsiNo === ''}
            className={pageStyle.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => {
              newBtnAction();
            }}
          >
            {t('IoTBoxSettingRowNewDialog.新規登録', '新規登録')}
          </Button>
        </DialogActions>
      </Dialog>
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={showTitle}
        okText={'OK'}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
    </>
  );
};

export default IoTBoxSettingRowNewDialog;
